import { Entity } from "../util/Entity";
export function eachChildren(container, f) {
    if (container.get("reverseChildren", false)) {
        container.children.eachReverse(f);
    }
    else {
        container.children.each(f);
    }
}
/**
 * Base class for [[Container]] layouts.
 */
export class Layout extends Entity {
}
Layout.className = "Layout";
Layout.classNames = Entity.classNames.concat([Layout.className]);
//# sourceMappingURL=Layout.js.map